export interface AddendumDefinition {
  name: string;
  type: "boolean" | "date";
}

/**
 * Contract / Default
 */
export enum ContractStatus {
  Draft = "draft",
  SentToPartner = "sentToPartner",
  SignedByPartner = "signedByPartner",
  // @TODO : ??Keep
  Rescinded = "rescinded",
  ForcedRescind = "forcedRescind",
}

export interface ContractSignedByPartnerAddendum {
  signatureDate: string | null | undefined;
}

export const ContractSignedByPartnerAddendumDef: AddendumDefinition[] = [
  { name: "signatureDate", type: "date" },
];

/**
 * Mayor Opinion
 */
export enum MayorOpinionStatus {
  Draft = "draft",
  SentByClient = "sentByClient",
  RequestSentToMunicipality = "requestSentToMunicipality",
  ResponseReceivedFromMayor = "responseReceivedFromMayor",
}

export interface MayorOpinionSentToMayorStatusAddendum {
  sentByPartner: boolean | undefined;
  sentByBetFirst: boolean | undefined;
}

export const MayorOpinionSentToMayorStatusAddendumDef: AddendumDefinition[] = [
  { name: "sentByPartner", type: "boolean" },
  { name: "sentByBetFirst", type: "boolean" },
];

/**
 * Mayor Agreement
 */
export enum MayorAgreementStatus {
  Draft = "draft",
  SentToMunicipality = "sentToMunicipality",
  ReceivedFromMunicipality = "receivedFromMunicipality",
  AcceptedByMunicipality = "acceptedByMunicipality",
  SentToMayor = "sentToMayor",
  AcceptedByMayor = "acceptedByMayor",
  RefusedByMayor = "refusedByMayor",
}

/**
 * Partner Mandate
 */
export enum PartnerExchangeStatus {
  Draft = "draft",
  CertificateSentByPartner = "certificateSentByPartner",
  MandateSentToPartnerForSigning = "mandateSentToPartnerForSigning",
  MandateReceivedFromPartner = "mandateReceivedFromPartner",
  MandateSentToTax = "mandateSentToTax",
  CertificateReceivedFromTax = "certificateReceivedFromTax",
  CertificateSentToCommission = "certificateSentToCommission",
  CertificateDoneByPartner = "certificateDoneByPartner",
  DocumentToReceiveFromPartner = "documentToReceiveFromPartner",
}

/**
 * Press Certificate
 * Regional Tax Certificate
 * Federal Certificate
 */
export enum CertificateRequestStatus {
  Draft = "draft",
  ReceivedFromPartner = "receivedFromPartner",
  Rescinded = "rescinded",
}

/**
 * Payment Plan
 */
export enum PaymentPlanStatus {
  Draft = "draft",
  SentToPartner = "sentToPartner",
  SignedByPartner = "signedByPartner",
}

export interface PaymentPlanStatusSentToPartnerAddendum {
  sentByMail: boolean | undefined;
  sentByPost: boolean | undefined;
}

export const PaymentPlanStatusSentToPartnerAddendumDef: AddendumDefinition[] = [
  { name: "sentByMail", type: "boolean" },
  { name: "sentByPost", type: "boolean" },
];

/**
 * Formal Notice Non Payment
 */
export enum FormalNoticeNonPaymentStatus {
  Draft = "draft",
  SentToPartner = "sentToPartner",
  PaidByPartner = "paidByPartner",
  SentToLawyer = "sentToLawyer",
}

export interface FormalNoticeNonPaymentStatusSentToPartnerAddendum {
  byMail: boolean | undefined;
  byPost: boolean | undefined;
}

export const FormalNoticeNonPaymentStatusSentToPartnerAddendumDef: AddendumDefinition[] =
  [
    { name: "byMail", type: "boolean" },
    { name: "byPost", type: "boolean" },
  ];

export interface FormalNoticeNonPaymentStatusPaidByPartnerAddendum {
  fullyPaid: boolean | undefined;
  partiallyPaid: boolean | undefined;
}

export const FormalNoticeNonPaymentStatusPaidByPartnerAddendumDef: AddendumDefinition[] =
  [
    { name: "fullyPaid", type: "boolean" },
    { name: "partiallyPaid", type: "boolean" },
  ];
